import { queryOptions } from '@tanstack/react-query';
import { getRoleDefinitions } from './api';

/**
 * Shared by `useRoleDefinitions` and the auth prefetch, so both sides agree on
 * the key and the cache policy.
 *
 * Failures go to Sentry without a toast: the app keeps the permissions the user
 * object carries, and role data is fetched during boot, where a toast has no
 * action the user can take.
 */
export function getRoleDefinitionsQueryOptions(accountId: number) {
  return queryOptions({
    queryKey: ['role_definitions', accountId],
    queryFn: async () => await getRoleDefinitions(accountId),
    staleTime: Infinity,
    meta: { captureExceptions: true },
  });
}
